
import _get from 'lodash/get'

import { FIELD_TYPE, REFDATA_MAP, DATE_FORMAT, CHOOSE_DATE } from '@/constants'
import { SERVICES } from './droplistData/services'
import { getTotal, updateTotal, enableShelterSection} from './helper/serviceHelper'


import { YES_NO } from '@/applicationDefinition/droplistData/boolean'
import { YES_NO_DONOT } from '@/applicationDefinition/droplistData/booleanDontno'

export default [
  {
    label: 'Services Needed',   
    type: FIELD_TYPE.HEADING
  }, 
  {
    apiKey: 'services.type',
    label :'What type of assistance do you need? (Check all that apply)',
    //description: 'Check all that apply',
    required: true,
    type: FIELD_TYPE.CHECKBOX_GROUP,    
    options() {
      return SERVICES
    },
    onFieldSet(value, application,store) {
      updateTotal(value, application)
      enableShelterSection(value, application)
    },        
  },

  {
    apiKey: 'services.rentMortgage',
    label: 'How much do you need for Rent/Mortgage? ',    
    type: FIELD_TYPE.CURRENCY,
    required: true,  
    visible(application) {
      const service = application.services.type
      if (service && service.find(item => item === 'rentMortgage')) {
        return service.find(item => item === 'rentMortgage').length > 0
      }
    },
    onFieldSet(value, application, store) {   
      getTotal(value, application)      
    }
    
  },
  {
    apiKey: 'services.securityDeposit',
    label: 'How much do you need for Security Deposit? ',    
    type: FIELD_TYPE.CURRENCY,
    required: true,  
    visible(application) {
      const service = application.services.type
      if (service && service.find(item => item === 'securityDeposit')) {
        return service.find(item => item === 'securityDeposit').length > 0
      }
    },
    onFieldSet(value, application, store) {      
      getTotal(value, application) 
    }
  },
  {
    apiKey: 'services.utilities',
    label: 'How much do you need for Utilities? ',    
    type: FIELD_TYPE.CURRENCY,
    required: true,  
    visible(application) {
      const service = application.services.type
      if (service && service.find(item => item === 'utilities')) {
        return service.find(item => item === 'utilities').length > 0
      }
    },
    onFieldSet(value, application, store) {      
      getTotal(value, application) 
    }
  },
  {
    apiKey: 'services.carAssistance',
    label: 'How much do you need for Car Assistance? ',    
    type: FIELD_TYPE.CURRENCY,
    required: true,  
    visible(application) {
      const service = application.services.type
      if (service && service.find(item => item === 'carAssistance')) {
        return service.find(item => item === 'carAssistance').length > 0
      }
    },
    onFieldSet(value, application, store) {      
      getTotal(value, application) 
    }
  },
  {
    apiKey: 'services.transportation',
    label: 'How much do you need for Transportation? ',    
    type: FIELD_TYPE.CURRENCY,
    required: true,  
    visible(application) {
      const service = application.services.type
      if (service && service.find(item => item === 'transportation')) {
        return service.find(item => item === 'transportation').length > 0
      }
    },
    onFieldSet(value, application, store) {      
      getTotal(value, application) 
    }
  },
  {
    apiKey: 'services.medicalExpenses',
    label: 'How much do you need for Medical Expenses? ',    
    type: FIELD_TYPE.CURRENCY,
    required: true,  
    visible(application) {
      const service = application.services.type
      if (service && service.find(item => item === 'medicalExpenses')) {
        return service.find(item => item === 'medicalExpenses').length > 0
      }
    },
    onFieldSet(value, application, store) {      
      getTotal(value, application) 
    }
  },
  {
    apiKey: 'services.food',
    label: 'How much do you need for Food? ',    
    type: FIELD_TYPE.CURRENCY,
    required: true,  
    visible(application) {
      const service = application.services.type
      if (service && service.find(item => item === 'food')) {
        return service.find(item => item === 'food').length > 0
      }
    },
    onFieldSet(value, application, store) {      
      getTotal(value, application) 
    }
  },
  {
    apiKey: 'services.childCare',
    label: 'How much do you need for Childcare? ',    
    type: FIELD_TYPE.CURRENCY,
    required: true,  
    visible(application) {
      const service = application.services.type
      if (service && service.find(item => item === 'childCare')) {
        return service.find(item => item === 'childCare').length > 0
      }
    },
    onFieldSet(value, application, store) {      
      getTotal(value, application) 
    }
  },
  {
    apiKey: 'services.other',
    label: 'How much do you need assistance with Other Service(s)? ',    
    type: FIELD_TYPE.CURRENCY,
    required: true,
    visible(application) {
      const service = application.services.type
      if (service && service.find(item => item === 'other')) {
        return service.find(item => item === 'other').length > 0
      }
    },
    onFieldSet(value, application, store) {      
      getTotal(value, application) 
    }
  },
  {
    apiKey: 'services.total',
    label: 'Total Services Needed',    
    type: FIELD_TYPE.CURRENCY,
    disabled: true,           
    visible(application) {
      const service = application.services.type
      if (service) {       
        return service.length > 0
      }
    }
  },
  {
    apiKey: 'services.otherServices',
    label: 'Are there any other services you would like us to consider, if so, please describe them here:',    
    type: FIELD_TYPE.TEXTAREA,
    maxCharacter: 300,
    required: true,
    maxRows: 2
  },
  
  {
    apiKey: 'services.events',
    label: 'Describe the event(s) that led to the current financial crisis.',    
    type: FIELD_TYPE.TEXTAREA,
    maxCharacter: 2500,
    required: true,
    maxRows: 2
  },
]